import json from "@/data/copy/site-ui.json";
import { createCopyGetter } from "@/lib/localize-copy";

export const getSiteUiCopy = createCopyGetter(json);
